/**
 * @Author: ikoros
 * @Date:   2020-04-06T18:18:25+08:00
 * @Last modified by:   ikoros
 * @Last modified time: 2020-04-25T22:41:45+08:00
 */

 import React, { Suspense, lazy } from 'react';
 import { HashRouter, Route, Switch } from 'react-router-dom';

import Loading from './../component/basic-loading';

const RouterList = [
    {component: lazy(()=>import('./../module/home')), pathname: '/'},
    {component: lazy(()=>import('./../module/news')), pathname: '/news/:id?'},
    {component: lazy(()=>import('./../module/article')), pathname: '/article/:id'},
    {component: lazy(()=>import('./../module/view')), pathname: '/view/:id'},
    {component: lazy(()=>import('./../module/video')), pathname: '/video/*-*.mp4-*'},
];

export default (props) => {
    const menu = props.menu;
    const refresh = props.refresh;
    return (
        <div className="root-router">
            <Suspense fallback={<Loading loading={true} />}>
                <HashRouter>
                    <Switch>
                        {
                            RouterList.map((item, i) => {
                                return <Route
                                key={'router' + i}
                                path={item.pathname}
                                exact
                                render={(props) => <item.component {...props} menu={menu} refresh={refresh} />}
                                />
                            })
                        }
                    </Switch>
                </HashRouter>
            </Suspense>
        </div>
     )
}
